import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SaveEditableViewIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SaveEditableView",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.02 2.05H3.98C2.91 2.02 2.02 2.87 2 3.94v21.19c0 .47.16.92.47 1.27l2.89 2.88c.37.42.9.66 1.46.66h21.2c1.07.03 1.96-.82 1.98-1.89V3.98c0-1.07-.88-1.93-1.95-1.93h-.04ZM24.79 28.5c0 .19-.14.34-.33.35H9.48c-.19 0-.35-.16-.35-.35v-3.87c0-.57.46-1.03 1.03-1.03h13.6c.56 0 1.02.44 1.03 1v3.89Zm.55-11.51c0 .99-.8 1.8-1.8 1.8H8.5c-.99.02-1.81-.77-1.83-1.76V4.08c0-.48.4-.87.89-.86h16.88c.48 0 .87.39.87.87l.02 12.89Z"
    })
  }));
};